import { render } from "./authors.vue?vue&type=template&id=3b3fcfc1"
import script from "./authors.vue?vue&type=script&lang=js"
export * from "./authors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__